import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Chart } from 'chart.js/auto';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dicdashboard.component.html',
  styleUrl: './dicdashboard.component.css'
})
export class dicDashboardComponent implements AfterViewInit {

  totalEvents = 0
  completedEvents = 0;
  upcomingEvents = 0;
  DistrictCode: any;
  constructor(private formBuilder: FormBuilder, private apiService: ApiService, private route: ActivatedRoute,
    private toastr: ToastrService, private router: Router,
    public commonService: CommonService) { }

  ngAfterViewInit(): void {
    this.LoadDetails();
    this.createChart();
  }

  LoadDetails() {
    const filters = {
      fromDate: '',        // Format as 'YYYY-MM-DD' if needed
      toDate: '',            // Format as 'YYYY-MM-DD' if needed
      districtCode: '',
      intervention: '',
      component: ''
    };

    filters.districtCode =(String)(!isNaN(parseInt(sessionStorage.getItem("districtCode") || "", 10)) ? parseInt(sessionStorage.getItem("districtCode") || "", 10) : ''),

      this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETTOTALCOUNT, filters).subscribe(
      result => {
        if (result.status) {          
          const dashboard = result.namedDataSets.DashboardCounts[0];

          this.totalEvents =      dashboard.DICTotalEvents;
          this.completedEvents =  dashboard.DICCompletedEvents;;
          this.upcomingEvents =   dashboard.DICPendingEvents;
          
        }
      }
    )


  }

  createChart() {
    const ctx = document.getElementById('salesChart') as HTMLCanvasElement;

    if (!ctx) {
      console.error('Canvas element not found!');
      return;
    }

    new Chart(ctx, {
      type: 'line', // Change this to your desired chart type (bar, pie, etc.)
      data: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun','Jul','Aug','Sept','Oct','Nov','Dec'],
        datasets: [{
          label: 'Budget (₹)',
          data: [400, 500, 700, 800, 650, 900,300,450,650,550,700,900],
          borderColor: 'rgba(13, 130, 130, 13)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          fill: true
        }]
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  }

  CardRedirection(event: any) {
    //const buttonId = event.target.id;
    const buttonId = (event.currentTarget as HTMLElement).id;
    switch (buttonId) {
      
      case 'btnTotalEvents':
        this.commonService.searchText = '';
        this.router.navigate(['/reports/alltotaleventlist']);
        break;
      case 'btnCompletedEvents':
        this.commonService.searchText = 'completed';
        this.router.navigate(['/reports/allcompletedeventlist']);
        break;
      case 'btnUpcomingEvents':
        this.commonService.searchText = 'created';
        this.router.navigate(['/reports/allscheduledeventlist']);
        break;

      default:
        window.location.reload();
        break;
    }
  }

}


